export default __webpack_public_path__ + "static/media/BrainBreak cards71.d96e7113.png";